{
  "success": true,
  "errorMessage": "",
  "Wordings": [
    {
      "categoryID": 7,
      "category": "Travel",
      "docFullName": "Travel Insurance - Outbound",
      "Link": "/pdf/uae/wording/Travel_Terms_And_Conditions Outbound.pdf",
      "SortOrder": 3
    }
  ]
}
